import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import { supabaseClient } from "../utils/supabase";

export interface Entry {
    entry_id: string;
    submitted_at: string | null;
    [key: string]: any;
}

export function useSelectEntry(
    entryId: string | undefined,
    options?: Omit<UseQueryOptions<Entry | null>, "queryKey" | "queryFn">
) {
    return useQuery({
        queryKey: ["entry", entryId],
        queryFn: async (): Promise<Entry | null> => {
            if (!entryId) return null;

            const { data, error } = await supabaseClient.from("entries").select("*").eq("entry_id", entryId).single();

            if (error) {
                console.error("Failed to fetch entry data:", error);
                throw error;
            }

            return data;
        },
        enabled: !!entryId,
        retry: (failureCount, error: any) => {
            // Don't retry if entry doesn't exist (PGRST116)
            if (error?.code === "PGRST116") {
                return false;
            }
            return failureCount < 3;
        },
        ...options,
    });
}
